






import { TableColumn } from "element-ui/types/table-column";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ListTemplateComponent extends Vue {
  @Prop()
  public name?: string;

  @Prop()
  private items?: any[];

  @Prop()
  private selectionChange?: (selectedItems: any[]) => {};

  @Prop()
  private rowClassNameFunction?: (row: any, rowIndex: number) => boolean;

  @Prop()
  private rowClick?: (row: any) => {};

  private openItem(item: any, cell: TableColumn, event: any) {
    this.$emit("open", item);
  }

  private handleSelectionChange(val: any[]) {
    if (this.selectionChange) {
      this.selectionChange(val);
    }
  }

  private tableRowClassName({row, rowIndex}: { row: any, rowIndex: number }) {
    if (this.rowClassNameFunction) {
      if (this.rowClassNameFunction(row, rowIndex)) {
        return "row-warning";
      }
    }
    return "";
  }

  private handleCurrentChange(val: any) {
    if (this.rowClick) {
      this.rowClick(val);
    }
  }
}
